import InsertAreaDialog from './insertAreaDialog'
export default InsertAreaDialog
